import { yearInReviewsClient } from "../api/ApiClients";
import ServiceBase from "./ServiceBase";
import { CoachYearAnalyticsDto } from "@growth-machine-llc/stridist-api-client";

class CoachAnalyticsService extends ServiceBase {
  async getCoachYearAnalytics(
    coachId: number,
    year: number,
  ): Promise<CoachYearAnalyticsDto> {
    return yearInReviewsClient.getCoachYearAnalytics(coachId, year);
  }
}

export default new CoachAnalyticsService();
